import React from 'react';
import { Panel } from './view/panel';

export const renderRule = {
  match: (item, cmsOption) => item.itemTypeCode === 'Panel', 
  itemElt: (item, cmsOption) => <Panel item={item} cmsOption={cmsOption} />
}